import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from 'src/app/shared/shared.module';
import { TrackLinkLabelComponent } from './track-link-label/track-link-label.component';
import { TrackLinkLabelsComponent } from './track-link-labels.component';

@NgModule({
  declarations: [TrackLinkLabelsComponent, TrackLinkLabelComponent],
  imports: [CommonModule, SharedModule],
})
export class TrackLinkLabelsModule {}
